<template>
  <section class="about-milestone content-section">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="12">
          <h2 class="content-section-title">MILESTONE</h2>
          <b-row class="guide-wrap mx-3" align-v="end" align-h="between">
            <b-col>
              <p class="mb-0 text-danger">1990-2000: Start-up</p>
              <p>
                Founded Scan Top in Taiwan and started selling wipers to all
                over the world.
              </p>
              <p class="mb-0 text-danger">2000-2010: Growth</p>
              <p>
                Invested a factory in China and manufacture high-quality wiper
                blades.
              </p>
              <p class="mb-0 text-danger">2010-2020: Transition</p>
              <p>
                Advanced the factory from traditional production to automated
                and intelligent production.
              </p>
              <p class="mb-0 text-danger">2020-2026: Sustainability</p>
              <p>
                Focused on ESG, renewable energy, and carbon footprint reduction.
              </p>
            </b-col>
            <b-col cols="auto">
              <b-img src="@/assets/images/about/scantop_35.png" fluid></b-img>
            </b-col>
          </b-row>
          <b-row class="px-3" style="justify-content-start">
            <MileStoneItem
              v-for="(milestone, i) in milestones"
              :key="i"
              :milestone="milestone"
            />
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import BgIcon from "@/components/BgIcon";
import MileStoneItem from "./_milestoneitem";

export default {
  components: { BgIcon, MileStoneItem },
  data() {
    return {
      guides: [
        { icon: "folder", desc: "Administration & System" },
        { icon: "atom", desc: "Technology" },
        { icon: "star", desc: "Certificates" },
      ],
      milestones: [
        {
          year: 1991,
          color: "#f4c13c",
          desc: ['Set up "Scan Top Enterprise Co., Ltd."in Taipei, Taiwan.'],
        },
        {
          year: 2001,
          color: "#f68c4d",
          desc: [
            "Established “Danyang UPC Auto Par t s Co., L t d .” i n China.",
          ],
        },
        {
          year: 2003,
          color: "#eb74a0",
          desc: ["Established a Rubber Research Laboratory."],
        },
        {
          year: 2008,
          color: "#8f7eb5",
          desc: [
            "Implemented ERP system to ensure FIFO Method and TQC control capabilities ",
          ],
        },
        {
          year: 2011,
          color: "#90c030",
          desc: ["Established Research and Development Department"],
        },
        {
          year: 2014,
          color: "#19a29b",
          desc: [
            "Established Automated Powder Coating system for Nature Rubber.",
            "Developed an Automated Assembly Machine.",
          ],
        },
        {
          year: 2016,
          color: "#5393c3",
          desc: [
            "Established Automated Packaging Machine.",
            "Established Automated Powder Paint line.",
            "Installed Barcode Traceability System.",
          ],
        },
        {
          year: 2018,
          color: "#1130b8",
          desc: ["Started using QAD management system."],
        },
        {
          year: 2019,
          color: "#1f7111",
          desc: ["Developed an Automated Assembly Line."],
        },
        {
          year: 2020,
          color: "#84a925",
          desc: [
            "Established a new factory in Yilan, Taiwan.",
            "Established an Automated storage and retrieval system.",
          ],
        },
        {
          year: 2021,
          color: "#ff5733",
          desc: ["Installing new solar panels in Yilan, Taiwan."],
        },
        {
          year: 2024,
          color: "#33c3ff",
          desc: ["Mplementing MES/QMS Management System."],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.guide-wrap {
  margin-bottom: 50px;
  padding: 10px 0;
  border: 2px solid #ccc;
  border-radius: 5px;
}
@media (min-width: 992px) {
  .guide-wrap {
    // width: 70%
  }
}
</style>